module.exports = function(ejs) {
var __t, __p = '';
__p += '<div class="ggs-gallery-vote-frame"><ggs-spinner class="ggs-gallery-vote-frame__spinner"></ggs-spinner><div class="ggs-gallery-vote-frame__iframe-parent"></div></div>';
return __p
}